module.exports = __webpack_public_path__ + "media/images/footer_page/claims/step4-1453ff4fb035eb046b7556bad57380b7.svg";